<template>
  <div class="flex h-full flex-col justify-between p-1 sm:gap-2 sm:p-2">
    <div class="flex items-center justify-between">
      <div>
        <slot name="top-left" />
      </div>
      <div>
        <slot name="top-right" />
      </div>
    </div>
    <slot />
  </div>
</template>
